<template>
    <div>
        <guest-or-account-modal :checkout="true" :show="!chosenGuest && guest" @guest="guestCheckout"></guest-or-account-modal>
        <login-checker :user="user" v-if="checkLogin" @close="reload"></login-checker>
        <template v-if="hasOrder">
            <div class="box checkout-box">
                <div class="box-inner box-copy">
                    <checkout-address
                        :firstname="shippingAddress.firstname"
                        :lastname="shippingAddress.lastname"
                        :company-name="shippingAddress.company_name"
                        :country="shippingAddress.country"
                        :address-one="shippingAddress.address"
                        :address-two="shippingAddress.address_two"
                        :address-three="shippingAddress.address_three"
                        :county="shippingAddress.county"
                        :city="shippingAddress.city"
                        :phone="shippingAddress.phone"
                        :email="shippingAddress.email"
                        :zip="shippingAddress.zip"
                        :initial-phone="contactPhone"
                        :initial-email="contactEmail"
                        @updateBilling="updateAddresses"
                        @contact="updateContact"
                        @saved="refreshOrder"
                    ></checkout-address>
                </div>
            </div>
            <div class="box checkout-box">
                <div class="box-inner box-copy">
                    <delivery-options
                        :current="shippingOption"
                        :collection="collection"
                        @saved="refreshPaymentOptions"
                    ></delivery-options>
                </div>
            </div>
            <div class="box checkout-box">
                <div class="box-inner box-copy">
                    <checkout-address
                        :step="3"
                        type="billing"
                        :company-name="billingAddress.company_name"
                        :firstname="billingAddress.firstname"
                        :lastname="billingAddress.lastname"
                        :country="billingAddress.country"
                        :address-one="billingAddress.address"
                        :address-two="billingAddress.address_two"
                        :address-three="billingAddress.address_three"
                        :county="billingAddress.county"
                        :city="billingAddress.city"
                        :phone="billingAddress.phone"
                        :email="billingAddress.email"
                        :initial-phone="contactPhone"
                        :initial-email="contactEmail"
                        :zip="billingAddress.zip"
                    ></checkout-address>
                </div>
            </div>
            <div class="box checkout-box payment-details">
                <div class="box-inner box-copy">
                    <payment-details :key="paymentDetailsKey" :paypal-env="paypalEnv" step="4" @processing="checkLogin = false" :account-no="accountNo" :guest="guest"></payment-details>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="loading">
                <i class="fa fa-refresh fa-spin"></i> <span>Loading</span>
            </div>
        </template>
    </div>
</template>

<script>
    import Orders from '../../Services/Order.js';
    import Basket from '../../Services/Basket.js';
    import Checkout from '../../Services/Checkout.js';
    import ContactDetails from './ContactDetails.vue';
    import PaymentDetails from './PaymentDetails.vue';
    import CheckoutAddress from './CheckoutAddress.vue';
    import DeliveryOptions from './DeliveryOptions.vue';
    import GuestOrAccountModal from '../Elements/Modals/GuestOrAccountModal.vue';

    export default {
        components: {
            CheckoutAddress,
            DeliveryOptions,
            ContactDetails,
            PaymentDetails,
            GuestOrAccountModal
        },
        props: {
            paypalEnv: {
                type: String,
                default: 'sandbox',
            },
            chosenGuest: {
                type: Boolean,
                default: false,
            },
            user: {
                type: Boolean,
                default: false,
            },
            guest: {
                type: Boolean,
                default: true,
            },
            accountNo: {
                type: String|Number,
                default: null,
            }
        },
        methods: {
            reload() {
                document.location.reload();
            },
            refreshPaymentOptions() {
                /**
                 * We do this so that paypal gets refreshed when delivery options change,
                 * this is because there is a bug when you selected paypal, open the dialog
                 * and then close it and change your delivery it won't take it into account
                 */
                this.paymentDetailsKey = this.paymentDetailsKey + 1;
            },
            guestCheckout() {
                window.location = '/checkout?chosen=1';
            },
            updateAddresses(val) {
                this.billingAddress = val;
                this.shippingAddress = val;
            },
            updateContact(val) {
                this.prefillEmail = val.email;
                this.prefillPhone = val.phone;
            },
            refreshOrder() {
                this.service.refresh();
                this.baskets.refresh();
            }
        },
        data() {
            return {
                service: Orders,
                checkout: Checkout,
                baskets: Basket,
                collection: false,
                prefillEmail: null,
                prefillPhone: null,
                checkLogin: this.user,
                paymentDetailsKey: 1,
            }
        },
        mounted() {
            this.service.getOrder()
        },
        computed: {
            order() {
                return this.service.order;
            },
            shippingAddress: {
                get() {
                    return this.order.shipping_details
                },
                set(val) {
                    this.order.shipping_details = val;
                }
            },
            billingAddress: {
                get() {
                    return this.order.billing_details
                },
                set(val) {
                    this.order.billing_details = val;
                }
            },
            hasOrder() {
                return !_.isEmpty(this.order);
            },
            shippingOption() {
                let option = _.find(this.order.lines, line => {
                    return line.is_shipping && !line.is_manual && (line.sku != 'long_lengths_delivery');
                });
                if (!option) {
                    return null;
                }
                return option.sku;
            },
            contactEmail() {
                if (this.order.contact_details.email) {
                    return this.order.contact_details.email;
                } else if (this.prefillEmail) {
                    return this.prefillEmail;
                }
                return this.order.user ? this.order.user.email : null;
            },
            contactPhone() {
                if (this.order.contact_details.phone) {
                    return this.order.contact_details.phone;
                } else if (this.prefillPhone) {
                    return this.prefillPhone;
                }
                return this.order.user && this.order.user.details ? this.order.user.details.contact_number : null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .loading {
        margin:20% 0;
        font-size:1.5em;
        color:#adadad;
        text-align:center;
        text-transform:uppercase;
        font-weight:600;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/CheckoutSteps.vue